import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Button,
} from "@mui/material";
import { ArrowDropDown, Search } from "@mui/icons-material";
// import { serverUrl } from '../server';
import { deleteRequest, getRequest, patchRequest, server } from "../config";
import moment from "moment";
import { toast } from "react-toastify";
import PartnerProfile from "../components/PartnerProfile";

const DeletedUsers = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [partnerPanel, setpartnerPanel] = useState(null)
  const [actualValue, setactualValue] = useState({name:'All Cities'})
  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage, selectedCity]);

  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCities = async () => {
    try {
      const uri = server.uri + "cities";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCities(citiesData);
        setbackData(citiesData);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchCities();
  }, []);
   const handleRecoverUser = async (partner) => {   
      if (!window.confirm("Are you sure you want to recover this user?")) {
        return;
      }
      try {
       const res= await patchRequest(`${server.uri}/users/${partner}`, {
          isDeleted:false
        });
        if(res!==200){  
         toast.error("Failed to recover partner");
         return
        }

        toast.success("User recover successfully");
      await fetchCustomers()
      } catch (err) {
        console.error(err);
        alert("Failed to delete User");
      }
    }

  const fetchCustomers = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { pincode: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };
      let cityid = "";
      if (selectedCity && selectedCity.length > 0) {
        cityid = `,"city":${selectedCity},`;
        console.log(cityid);
      }
      if(selectedCity){
        
      
      const response = await getRequest(
        `${server.uri}deletedUsers?filter={
        "where":{
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}},
         {"pincode":{"like":"${searchQuery}"}}
        
      ],"city":"${selectedCity}"},"skip":"${filter.skip}",
        "limit":"${filter.limit}"
        ,"order":"createdAt desc"}`
      );
      //   console.log(response);

      setCustomers(response);
      const responseCount = await getRequest(
        `${server.uri}deletedUsers/count?where={
        
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}},
         {"mobileNumber":{"like":"${searchQuery}"}}
      ],"city":"${selectedCity}"}`
      );
     
      console.log(responseCount);

      setTotalCount(responseCount.count);
    }
    else{
        const response = await getRequest(
            `${server.uri}deletedUsers?filter={
            "where":{
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}},
             {"pincode":{"like":"${searchQuery}"}}
            
          ]},"skip":"${filter.skip}",
            "limit":"${filter.limit}"
            ,"order":"createdAt desc"}`
          );
          //   console.log(response);
    
          setCustomers(response);
          const responseCount = await getRequest(
            `${server.uri}deletedUsers/count?where={
            
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}},
             {"pincode":{"like":"${searchQuery}"}}
          ]}`
          );
         
          console.log(responseCount);
    
          setTotalCount(responseCount.count);
    }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value)
    setPage(0); // Reset to the first page when city changes
  };
   const handleDeletePartnerPermanent = async (partner) => {   
      if (!window.confirm("Are you sure you want to delete this partner?")) {
        return;
      }
      try {
       const res= await deleteRequest(`${server.uri}/users/${partner}/delete`);
        if(res!==204){  
         toast.error("Failed to delete partner");
         return
        }
        toast.success("Partner deleted successfully");
 await fetchCustomers()
      } catch (err) {
        console.error(err);
        alert("Failed to delete partner");
      }
    }
  if(partnerPanel){
    return(<PartnerProfile partner={partnerPanel} onClose={()=>setpartnerPanel(null)}/>)
  }
  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]; // Example city list
  return (
    <Container>
      <Typography variant="h4" sx={{ marginTop: 8, marginBottom: 2 }}>
     Deleted Users
      </Typography>

      {/* Search Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* Search Bar */}
        <TextField
          variant="outlined"
          placeholder="Search by name/mobile number/pincode"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />
        

        {/* City Dropdown */}
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
          {/* <InputLabel>City</InputLabel> */}
          <Autocomplete
            value={actualValue}
            onChange={handleCityChange}
            // label="City"
            getOptionLabel={(option) => option?.name}
            options={allCities}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search City"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box>
      <Typography variant="subtitle1" sx={{textAlign:'right'}} gutterBottom>
        Total Users: <strong>{totalCount}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
               
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
               
                <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Pincode</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>User Type</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Is Deleted</TableCell>
               
                <TableCell sx={{ fontWeight: 'bold' }}>Joined At</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((customer) => (
                <TableRow  sx={{
                    '&:nth-of-type(even)': {
                      backgroundColor: '#f9fafb', // Alternate row color for better readability
                    },
                  }} key={customer.userId}>
                
                  <TableCell onClick={()=>{
                    if(customer?.userType==='partner'){
                        setpartnerPanel(customer)
                    }
                  }}>{customer?.name}</TableCell>
                
                  <TableCell>{customer?.mobileNumber}</TableCell>
                  <TableCell>{customer?.city}</TableCell>
                  <TableCell>{customer?.pincode}</TableCell>
                  <TableCell>{customer?.userType}</TableCell>
                  <TableCell>{customer?.status}</TableCell>
                  <TableCell >{(customer?.isDeleted)?'True':'False'}</TableCell>
                  <TableCell>{moment(customer?.createdAt).startOf('hour').fromNow()}</TableCell>
                  <TableCell><Button type="button" variant="contained" onClick={()=>handleRecoverUser(customer?.userId)}>Recover</Button></TableCell>
                  <TableCell><Button type="button" variant="contained" color="error" onClick={()=>handleDeletePartnerPermanent(customer?.userId)}>Delete</Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,100,200,10000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
};

export default DeletedUsers;
